import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var GolfIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "33",
    viewBox: "0 0 32 33"
  }, props), React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M17 11.343v10.313c0 .57.448 1.031 1 1.031s1-.462 1-1.031V11.342c0-.57-.448-1.031-1-1.031s-1 .462-1 1.031zm-6 4.125v6.188c0 .57.448 1.031 1 1.031s1-.462 1-1.031v-6.188c0-.57-.448-1.031-1-1.031s-1 .462-1 1.031zm9 10.313v7.218c0 .57.448 1.032 1 1.032s1-.462 1-1.032v-7.217c0-.57-.448-1.032-1-1.032s-1 .462-1 1.032zM10 33v-7.22c0-.569-.448-1.03-1-1.03s-1 .461-1 1.03V33c0 .569.448 1.03 1 1.03s1-.461 1-1.03z"
  }), React.createElement("path", {
    d: "M6 26.812h18c.552 0 1-.462 1-1.031 0-.57-.448-1.032-1-1.032H6c-.552 0-1 .462-1 1.032 0 .57.448 1.031 1 1.031zm21-14.437h-9c-.552 0-1-.462-1-1.032V7.515c0-1.213.687-2.314 1.758-2.816l7-3.282a2.924 2.924 0 0 1 2.866.215A3.12 3.12 0 0 1 30 4.234v5.047c0 1.708-1.343 3.093-3 3.093zm-8-2.063h8c.552 0 1-.462 1-1.031V4.234c0-.351-.173-.678-.459-.868a.97.97 0 0 0-.955-.071l-7 3.281a1.034 1.034 0 0 0-.586.94v2.796zM5 16.5h7c.552 0 1-.462 1-1.032v-2.784c0-1.223-.698-2.331-1.782-2.828l-5-2.291a2.924 2.924 0 0 0-2.853.233A3.12 3.12 0 0 0 2 10.392v3.014C2 15.114 3.343 16.5 5 16.5zm6-2.063H5c-.552 0-1-.462-1-1.031v-3.014c0-.349.171-.674.455-.864a.974.974 0 0 1 .951-.078l5 2.291c.361.166.594.535.594.943v1.753z"
  })));
});

export default GolfIcon;
//# sourceMappingURL=golf.svg.js.map
